import React from 'react';

import { Wrapper } from 'components/atom/Grid';

import { Container, NavButton } from './styles';

interface ITabsNavigationProps {
  tab: number;
  setTab: (tab: number) => void;
  options: string[];
}

const TabsNavigation: React.FC<ITabsNavigationProps> = ({ setTab, tab, options }) => (
  <Container>
    <Wrapper>
      {options?.map((tabLabel, index) => (
        <NavButton key={index} onClick={() => setTab(index)} active={tab === index}>
          {tabLabel}
        </NavButton>
      ))}
    </Wrapper>
  </Container>
);

export default TabsNavigation;
